var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('Page',{attrs:{"title":"My Reservations"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('YearSelector',{on:{"select":_vm.setYear}})]},proxy:true}])},[_c('List')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }